<template>
  <div></div>
</template>

<script>
import { apiService } from '@/utils/api/index';
import { genericError } from '@/utils/alerts.service';

export default {
  methods: {
    validateUser() {
      let endpoint = `/users/email/validation/${this.$route.params.dir}/${this.$route.params.org}/${this.$route.params.user}/`;
      if (this.$route.query && this.$route.query.agency_flow === 'true') {
        endpoint += '?agency_flow=true';
      }

      apiService
        .get(endpoint)
        .then(() => {
          window.location.replace(
            `${process.env.VUE_APP_PROTOCOL_PREFIX}://${process.env.VUE_APP_ADMIN_SUBDOMAIN}.${process.env.VUE_APP_ROOT_CLIENT}/`
          );
        })
        .catch(e => {
          genericError.message = e.data[0];
          this.$store.dispatch('showUserMessage', genericError);
        });
    },
  },
  mounted() {
    this.validateUser();
  },
};
</script>
